export default "__VITE_ASSET__BIRVYuZf__"